import * as Backend from './BackendRequest';

export const ChangeUserPassword = (oldPassword: string, newPassword: string) =>
  Backend.request('PATCH', `/user/password`, {}, { oldPassword, newPassword });

export const ChangeUserEmail = (password: string, email: string) => Backend.request('PATCH', `/user/email`, {}, { password, email });
